<template>
  <div class="about">
    <PageTitle
      :headerTitle="$t('KnowMoreAboutUs')"
      :headerSubTitle="$t('Ourlatestnewsandlearningarticles')"
    ></PageTitle>

    <VideoSection></VideoSection>
    <!-- <div class="service section-gap pt-5">

			<div class="container">
				<ServiceSection />
			</div>
    </div>-->
    <OurMissionSection></OurMissionSection>

    <ContactInfo></ContactInfo> 
    <div class="send-msg-form bg-gray-dark style-form">
      <div class="py-6">
        <div class="container">
          <div class="section-title-wrapper">
            <div class="row">
              <div class="col-sm-12 col-md-6 mx-auto text-center">
                <h2>{{ $t("SendUsMessage") }}</h2>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-10 col-lg-7 mx-auto">
              <!-- <SendMessage></SendMessage> -->
              <!-- <form> -->
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group mb-4">
                      <input
                        v-model="message.email"
                        type="email"
                        class="form-control form-control-lg"
                        id="inputEmail4"
                        :placeholder="$t('Email')"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group mb-4">
                      <input
                        v-model="message.Title"
                        type="text"
                        class="form-control form-control-lg"
                        id="inputEmail4"
                        :placeholder="$t('TitleMessage')"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group mb-4">
                      <textarea
                        v-model="message.Message"
                        name
                        id
                        class="form-control form-control-lg"
                        :placeholder="$t('Messages')"
                      ></textarea>
                    </div>
                  </div>
                </div>

                <button
                  @click="save"
                  type="submit"
                  class="btn text-white btn-success btn-block"
                >
                  {{ $t("GetinTouch") }}
                </button>
              <!-- </form> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import VideoSection from "Components/Sections/VideoSection.vue";
//import ServiceSection from "Components/Sections/ServiceSection.vue";
import OurMissionSection from "Components/Sections/OurMissionSection.vue";
//import TeamGridV2 from "Components/Sections/TeamGridV2.vue";
//import TestimonialSlider from "Components/Sections/TestimonialSlider.vue";
import ContactInfo from "Components/Sections/ContactInfo.vue";
// import SendMessage from "Components/Sections/SendMessage.vue";
import modulePageDetails from "@/store/PageDetails/modulePageDetails.js";

export default {
  data() {
    return {
      message: {},
    };
  },
  components: {
    // VideoSection,
    //ServiceSection,
    OurMissionSection,
    //TeamGridV2,
    //TestimonialSlider,
    ContactInfo,
    //SendMessage,
  },
  methods: {
    save() {
      debugger;
      this.message.ContactTypeID = 2;
      this.$store
        .dispatch("DetailsList/addComplain", this.message)
        .then((response) => {
          debugger;
          if (response.status == 200) {
            debugger;
            this.$router.push("/Home");
            this.message = {};
            //this.$router.go(-1);
          }
        })
        .catch(() => {});
    },
  },
  created() {
    debugger;
    if (!modulePageDetails.isRegistered) {
      debugger
      this.$store.registerModule("DetailsList", modulePageDetails);
      modulePageDetails.isRegistered = true;
    }
  },
};
</script>
